import React, {createContext, useContext, useState} from "react";
import api from "./api";
import {persistPreferredLanguage, safeStorage, shouldPersistPreferredLanguage} from "./errorReporting";

const AuthContext = createContext();

export const AuthProvider = ({children}) => {

    const [loaded, setLoaded] = useState(false);
    const [company, setCompany] = useState({});
    const [plan, setPlan] = useState({});
    const [user, setUser] = useState({});

    const mobileAppParam = new URLSearchParams(window.location.search).get('mobile_app')

    if(mobileAppParam) {
       safeStorage.set('mobile_app', 'true')
       safeStorage.set('is_ios', mobileAppParam === "ios")
    }

    const [isApp, setIsApp] = useState(
        mobileAppParam ? true : safeStorage.get('mobile_app') === "true"
    );
    const [isIos, setIsIos] = useState(
        mobileAppParam ? mobileAppParam === "ios" : safeStorage.get('is_ios') === "true"
    );

    if (!loaded && api.isLoggedIn()) {
        api.get_plan().then(setPlan)
        api.getMyCompany().then((c) => {
            setCompany(c)
            // Store company language preference - this takes priority over domain
            if (c.language) {
                safeStorage.set('oogst_company_language', c.language)
                // If company language changed or is different from current, reload to apply
                const currentLang = safeStorage.get('oogst_preferred_language')
                if (shouldPersistPreferredLanguage(currentLang, c.language)) {
                    persistPreferredLanguage(c.language)
                }
            }
        })
        api.getMe().then((u) => {
            console.log('Setting user id.', u.id)
            if (typeof window.clarity === 'function') {
                window.clarity("consent")
                window.clarity("identify", u.id.toString());
            }
            setUser(u)
        })
        setLoaded(true)
    }

    return (
        <AuthContext.Provider value={{user, setUser, plan, setPlan, company, setCompany, isIos, setIsIos, isApp, setIsApp}}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuthState = () => {
    const context = useContext(AuthContext);
    if (!context) throw new Error("useTranslationState must be used within a TranslationProvider");
    return context;
};

export const useAuth = () => {
    const {user, plan, company, isIos, isApp} = useAuthState();
    return {
        user,
        plan,
        company,
        measurementSystem: company?.measurements || 'metric',
        isIos,
        isApp
    };
};